import React from "react";

interface CardFooterProps {
  children?: React.ReactNode;
}

export const CardFooter = ({ children }: CardFooterProps) => {
  return <div className="bg-primary-50 p-4">{children}</div>;
};
